// import { metaTagString } from '../../utilities/meta_tags_util';

export default (urlPath, language, query, params) => {
  return {
    metaData: null,
  };
};
